const map = require('lodash/map')
const isNaN = require('lodash/isNaN')
const compact = require('lodash/compact')
const isString = require('lodash/isString')

export const numberArrayDefaultValue = value => {
    if (!value) { return undefined }
  
    const stringToNumber = stringValue => {
      const valueAsNumber = parseInt(stringValue, 10)
      return isNaN(valueAsNumber) ? undefined : valueAsNumber
    }
  
    if (isString(value)) {
      const valueAsNumber = stringToNumber(value)
      return valueAsNumber ? [ valueAsNumber ] : undefined
    }
  
    return compact(map(value, stringToNumber))
  }


// WEBPACK FOOTER //
// ./src/utils/query-params.ts